import React from 'react'
import { FaAndroid, FaBootstrap, FaCss3, FaHtml5, FaJava, FaJs, FaNode, FaReact} from 'react-icons/fa'
import{SiC, SiCplusplus, SiExpress, SiGit, SiGithub, SiKotlin, SiMongodb, SiMysql,SiFirebase ,SiPostman, SiPython, SiVisualstudiocode} from 'react-icons/si'
import{Slide} from 'react-awesome-reveal'

function skills() {
  return (
    <div className='min-h-screen flex flex-col justify-center items-center px-4 py-16'>
      <div className='max-w-7xl w-full'>
        <h1 className='text-5xl md:text-6xl font-bold text-center mb-4 gradient-text'>Skills</h1>
        <p className='text-lg md:text-xl text-center text-white/70 mb-12 max-w-2xl mx-auto'>
          Here are some skills which I developed over the last 2 years
        </p>
        
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
          {/* Frontend Card */}
          <Slide direction="up" triggerOnce={true}>
            <div className='glass-card group'>
              <div className='absolute -inset-0.5 bg-gradient-to-r from-accent-purple to-accent-cyan rounded-2xl opacity-0 group-hover:opacity-50 blur transition duration-300'></div>
              <div className='relative'>
                <h2 className='text-3xl font-bold text-center mb-6 gradient-text'>Frontend</h2>
                <div className='flex flex-wrap gap-3 justify-center'>
                  <div className='px-4 py-2 bg-gradient-to-r from-blue-500/20 to-blue-600/20 border border-blue-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaReact className='text-blue-400'/>
                    <span className='text-white font-medium'>React JS</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-yellow-500/20 to-yellow-600/20 border border-yellow-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaJs className='text-yellow-400'/>
                    <span className='text-white font-medium'>Javascript</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-purple-500/20 to-purple-600/20 border border-purple-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaBootstrap className='text-purple-400'/>
                    <span className='text-white font-medium'>Bootstrap</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-blue-500/20 to-blue-600/20 border border-blue-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaCss3 className='text-blue-400'/>
                    <span className='text-white font-medium'>CSS</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-orange-500/20 to-orange-600/20 border border-orange-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaHtml5 className='text-orange-400'/>
                    <span className='text-white font-medium'>HTML</span>
                  </div>
                </div>
              </div>
            </div>
          </Slide>

          {/* Backend Card */}
          <Slide direction="up" triggerOnce={true} delay={100}>
            <div className='glass-card group'>
              <div className='absolute -inset-0.5 bg-gradient-to-r from-accent-cyan to-accent-pink rounded-2xl opacity-0 group-hover:opacity-50 blur transition duration-300'></div>
              <div className='relative'>
                <h2 className='text-3xl font-bold text-center mb-6 gradient-text'>Backend</h2>
                <div className='flex flex-wrap gap-3 justify-center'>
                  <div className='px-4 py-2 bg-gradient-to-r from-green-500/20 to-green-600/20 border border-green-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaNode className='text-green-400'/>
                    <span className='text-white font-medium'>Node JS</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-cyan-500/20 to-cyan-600/20 border border-cyan-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiExpress className='text-cyan-400'/>
                    <span className='text-white font-medium'>Express JS</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-orange-500/20 to-orange-600/20 border border-orange-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiFirebase className='text-orange-400'/>
                    <span className='text-white font-medium'>Firebase</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-green-500/20 to-green-600/20 border border-green-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiMongodb className='text-green-400'/>
                    <span className='text-white font-medium'>MongoDB</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-blue-500/20 to-blue-600/20 border border-blue-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiMysql className='text-blue-400'/>
                    <span className='text-white font-medium'>MySQL</span>
                  </div>
                </div>
              </div>
            </div>
          </Slide>

          {/* Languages Card */}
          <Slide direction="up" triggerOnce={true} delay={200}>
            <div className='glass-card group'>
              <div className='absolute -inset-0.5 bg-gradient-to-r from-accent-pink to-accent-purple rounded-2xl opacity-0 group-hover:opacity-50 blur transition duration-300'></div>
              <div className='relative'>
                <h2 className='text-3xl font-bold text-center mb-6 gradient-text'>Languages</h2>
                <div className='flex flex-wrap gap-3 justify-center'>
                  <div className='px-4 py-2 bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaJava className='text-red-400'/>
                    <span className='text-white font-medium'>Java</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-purple-500/20 to-purple-600/20 border border-purple-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <span className='text-purple-400 font-medium'>Solidity</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-yellow-500/20 to-yellow-600/20 border border-yellow-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaJs className='text-yellow-400'/>
                    <span className='text-white font-medium'>Javascript</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-blue-500/20 to-blue-600/20 border border-blue-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiC className='text-blue-400'/>
                    <span className='text-white font-medium'>C</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-blue-500/20 to-blue-600/20 border border-blue-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiCplusplus className='text-blue-400'/>
                    <span className='text-white font-medium'>C++</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-blue-500/20 to-blue-600/20 border border-blue-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiPython className='text-blue-400'/>
                    <span className='text-white font-medium'>Python</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-purple-500/20 to-purple-600/20 border border-purple-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiKotlin className='text-purple-400'/>
                    <span className='text-white font-medium'>Kotlin</span>
                  </div>
                </div>
              </div>
            </div>
          </Slide>

          {/* Others Card */}
          <Slide direction="up" triggerOnce={true} delay={300}>
            <div className='glass-card group'>
              <div className='absolute -inset-0.5 bg-gradient-to-r from-accent-purple via-accent-cyan to-accent-pink rounded-2xl opacity-0 group-hover:opacity-50 blur transition duration-300'></div>
              <div className='relative'>
                <h2 className='text-3xl font-bold text-center mb-6 gradient-text'>Others</h2>
                <div className='flex flex-wrap gap-3 justify-center'>
                  <div className='px-4 py-2 bg-gradient-to-r from-green-500/20 to-green-600/20 border border-green-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <FaAndroid className='text-green-400'/>
                    <span className='text-white font-medium'>Android Studio</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-blue-500/20 to-blue-600/20 border border-blue-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiVisualstudiocode className='text-blue-400'/>
                    <span className='text-white font-medium'>VS Code</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-gray-500/20 to-gray-600/20 border border-gray-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiGithub className='text-gray-400'/>
                    <span className='text-white font-medium'>Github</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-red-500/20 to-red-600/20 border border-red-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiGit className='text-red-400'/>
                    <span className='text-white font-medium'>Git</span>
                  </div>
                  <div className='px-4 py-2 bg-gradient-to-r from-orange-500/20 to-orange-600/20 border border-orange-500/30 rounded-full flex items-center gap-2 hover:scale-110 hover:shadow-glow transition-all duration-300 cursor-pointer'>
                    <SiPostman className='text-orange-400'/>
                    <span className='text-white font-medium'>Postman</span>
                  </div>
                </div>
              </div>
            </div>
          </Slide>
        </div>
      </div>
    </div>
  )
}
export default skills
